import React from 'react';

interface Props {
  img: string;
  link?: string;
  alt: string;
  onClick?: () => void;
  id?: string;
}

interface Images {
  images: Array<Props>;
  styles?: string;
  target?: '_blank' | '_self' | '_parent' | '_top' | 'framename';
}

const Image = ({ images, styles, target }: Images) => {
  return (
    <div className={styles || ''}>
      {images.map((image, index) => (
        <div key={index}>
          <a id={image.id} href={image.link} target={target ?? '_self'} onClick={image.onClick}>
            <img src={image.img} alt={image.alt} />
          </a>
        </div>
      ))}
    </div>
  );
};

export default Image;
